<template>
    <modal
            name="confirm"
            height="auto"
            width="400px"
            class="modal-confirm"
    >
        <div class="window-header">
            {{title}}
            <a href="javascript:void(0)" class="close-modal pull-right" @click="$modal.hide('confirm')"><i
                    class="fa fa-times"></i></a>
        </div>
        <div class="modal-body">
          <div class="modal-body-text">{{msg}}</div>
            <br v-if="form.length > 0">
            <br v-if="form.length > 0">
            <div
                    v-for="(formItem, index) in form"
                    v-bind:key="formItem.name"
            >
                <b-form-checkbox
                        v-if="formItem['type'] === 'checkbox'"
                        :id="formItem.name"
                        v-model="form[index].value"
                        :name="'checkbox'+formItem.name"
                        value="y"
                        unchecked-value=""
                >
                    {{formItem.text}}
                </b-form-checkbox>
                <b-form-input
                        v-if="formItem['type'] === 'input'"
                        :id="formItem.name"
                        v-model="form[index].value"
                        :name="'checkbox'+formItem.name"
                        :placeholder="formItem.text"
                >
                </b-form-input>
            </div>
        </div>
        <div class="modal-footer">
            <button v-for="(button, index) in buttons" v-bind:key="index"
                    class="btn"
                    :class="'btn-' + (button['class'] || 'default')"
                    href="javascript:void(0);"
                    v-on:click="buttonAction(button['name'])"
                    type="button"
            >
                <span>{{button['text']}}</span>
            </button>
        </div>
    </modal>
</template>

<script>
    import {TokenMixin} from '@/assets/js/mixins/token-mixin';

    export default {
        name: 'ModalConfirm',
        mixins: [
            TokenMixin,
        ],
        props: {
            msg: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            buttons: {
                type: Array,
                default: function () {
                    return [
                        {
                            "name": "delete",
                            "text": "Yes, delete",
                            "class": "primary"
                        },
                        {
                            "name": "cancel",
                            "text": "Cancel"
                        }
                    ]
                }
            },
            form: {
                type: Array,
                default: function () {
                    return [
                        {
                            "name": "example1",
                            "text": "I confirm this action",
                            "type": "checkbox",
                            "value": "_checkbox",
                        },
                        {
                            "name": "example2",
                            "text": "Enter text",
                            "type": "_input",
                        }
                    ]
                }
            },

        },
        methods: {
            buttonAction(name) {
                this.$modal.hide('confirm');
                let formData = [];
                for (let index in this.form) {
                    if (!Object.keys(this.form[index]).includes('value') || !Object.keys(this.form[index]).includes('name')) {
                        console.log(index, 'keys', Object.keys(this.form[index]), this.form[index]);
                        continue;
                    }
                    formData[this.form[index]['name']] = this.form[index]['value'];
                }
                this.$emit('onModalСonfirmEvent', {'button': name, 'form' : formData});
            }
        }
    }
</script>
<style>
.modal-confirm .modal-body {
  white-space: pre;
}
.modal-body-text {
  max-height: 150px;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #fff #c33e3e;
}
</style>
